// extracted by mini-css-extract-plugin
module.exports = {"cardBox":"checkout-card_cardBox__r4_Uv","totalBox":"checkout-card_totalBox__NKVGL","boxTitle":"checkout-card_boxTitle__fquM4","noteTag":"checkout-card_noteTag__e_t8F"};